import React from 'react';
import WorkNodeBase from '../common/workNodeBase';
import WorkflowsSurface from '../surfaces/workflows/workflowsSurface';
import { CELL_WORKFLOWS_ALIAS } from '../domain/schema';

/**
 * CellWorkflowsNode — the Cell Workflows widget (`system.work.cell_workflows`).
 *
 * Thin: builds a SystemOfWorkClient (via WorkNodeBase) and renders the
 * self-loading WorkflowsSurface — the cell-workflow template library editor.
 *
 * The surface fetches its templates on mount. Keying it on the session object's
 * remount key (see WorkNodeBase.surfaceKey) re-runs that fetch when the session
 * is switched/selected and once when the `cell_workflows` value first loads, so
 * an always-mounted widget reflects live session data without remounting on every
 * unrelated update.
 */
class CellWorkflowsNode extends WorkNodeBase {
  getClassName() {
    return 'playground-work-node playground-cell-workflows-node';
  }

  renderBody() {
    return (
      <div className="mission-control-shell">
        <div className="mission-control-surface-body">
          <WorkflowsSurface key={this.surfaceKey(CELL_WORKFLOWS_ALIAS)} client={this.getClient()} />
        </div>
      </div>
    );
  }
}

export default CellWorkflowsNode;
